module.exports = __webpack_public_path__ + "static/media/oregon.0b18da9c.png";